import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../components/ui/accordion";
import { Reveal } from "../components/Reveal";
import Seo from "../components/Seo";
import { api } from "../lib/api";

export default function Faq() {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    api.get("/content/faqs").then((r) => setFaqs(r.data)).catch(() => {});
  }, []);

  const categories = [...new Set(faqs.map((f) => f.category))];

  return (
    <div data-testid="faq-page" className="pt-32 pb-24 min-h-screen relative">
      <Seo title="FAQ — ASCENDXP" description="Frequently asked questions about ASCENDXP, plans, billing, and security." />
      <div className="absolute top-10 left-1/2 -translate-x-1/2 w-[500px] h-[400px] rounded-full bg-indigo-600/10 blur-[120px]" />
      <div className="max-w-3xl mx-auto px-6 lg:px-8 relative">
        <Reveal className="text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-indigo-400 font-bold mb-4">Help Center</p>
          <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tighter">Frequently asked questions</h1>
        </Reveal>

        <div className="mt-12 space-y-10">
          {categories.map((cat) => (
            <Reveal key={cat}>
              <h2 className="font-heading font-bold text-lg text-zinc-300 mb-3">{cat}</h2>
              <Accordion type="single" collapsible className="space-y-3">
                {faqs.filter((f) => f.category === cat).map((f) => (
                  <AccordionItem key={f.id} value={f.id} data-testid={`faq-item-${f.id}`} className="glass rounded-2xl px-5 border-none">
                    <AccordionTrigger className="text-left font-medium hover:no-underline py-4">{f.question}</AccordionTrigger>
                    <AccordionContent className="text-zinc-400 leading-relaxed">{f.answer}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-14 text-center glass rounded-2xl p-8">
            <p className="text-zinc-400">Still have questions?</p>
            <Link to="/contact" className="btn-primary mt-4">Contact Support</Link>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
